const chainLists = {
  ES: {
    QSR: [
      "McDonald's", "Burger King", "Popeye's", "Telepizza", "KFC", "Viena Establiments", "Five Guys",
      "Pans & Co", "Rodilla", "Papizza", "Carl's Jr", "Taco Bell", "The Fitzgerald", "Papa John’s",
      "Pizza Móvil", "Don G", "Pomodoro", "Pizzería Carlos", "Basics", "Basics Dark", "Distrito Burger"
    ],
    CASUAL: [
      "Udon", "Ribs", "Hamb. Nostra", "La Tagliatella", "MasQMenos", "Volapié", "Goiko", "Tony Roma's",
      "Tommy Mels", "Chelinda", "La Mafia", "Cantina Mariachi", "Muerde la Pasta", "Lateral",
      "Lizarran", "Café y Tapas", "DHS", "FrescCo", "Singulares Cía del Trópico", "Grosso Napoletano",
      "Saona", "Ditaly", "La Boca Te Lía", "Vezzo"
    ],
    CAFE: [
      "McCafé", "Tim Horton's", "Jamaica", "Santa Gloria", "L'Obrador", "JVC", "Café de Indias",
      "Café y Té", "Panaria", "Rodilla Café", "Levadura Madre", "El Fornet", "Pans Café", "Dunkin’",
      "Bombon Boss", "La Julietta", "Syra Coffee"
    ]
  },
  PT: {
    QSR: [
      "Burger King", "Telepizza", "KFC", "Pans & Co", "Milt", "Sol", "La Tagliatella",
      "Taco Bell", "Pizza Hut", "Pret a Manger", "Pasta Café", "La Mafia", "Papa John’s"
    ]
  }
}

export default chainLists;
